import React, { useState, useEffect } from "react";
import "../App.css";
import "../index.css";

const Statistics = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch("https://test.visiontronic.cz/daily.php")
      .then((response) => response.json())
      .then((data) => setData(data));
  }, []);

  return (
    <div>
      <h1 className="statistics">Denní Statistika</h1>
      <p style={{ color: "white" }}>
        {new Date(data[0]?.LastTimeStamp).toLocaleDateString("cs-CZ")}
      </p>
      <table>
        <thead>
          <tr>
            <th>Lokace</th>
            <th>Mince</th>
            <th>KC</th>
            <th>EUR</th>
            <th>Terminal</th>
            {/* Add more <th> elements here for each column in your data */}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td style={{ textAlign: "left" }}>
                {item.TypeMachine == 2 ? (
                  <>
                    <div>
                      {item.StationName} - {item.Coin1}
                    </div>
                    <div>
                      {item.StationName} - {item.Coin2}
                    </div>
                  </>
                ) : (
                  item.StationName
                )}
              </td>
              <td>
                {item.TypeMachine == 2 ? (
                  <>
                    <div>{item.DailyHopper1Out}</div>
                    <div>{item.DailyHopper2Out}</div>
                  </>
                ) : (
                  item.DailyHopper1Out
                )}
              </td>
              <td>
                {new Intl.NumberFormat("cs-CZ", {
                  style: "currency",
                  currency: "CZK",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(item.Terminal_Kc)}
              </td>
              <td>
                {new Intl.NumberFormat("cs-CZ", {
                  style: "currency",
                  currency: "CZK",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(item.Cash_Kc)}
              </td>
              <td>
                {new Intl.NumberFormat("cs-CZ", {
                  style: "currency",
                  currency: "EUR",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(item.Cash_Eur)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Statistics;
